import { Requirements } from './types';

export const canUpdateConditionId = (requirements: Requirements) => {
  if (Object.values(requirements).every((r) => !!r)) {
    return true;
  }

  return false;
};
